
import { useNavigate } from "react-router";
import { StringHelper } from "./string-helper";
import Cookies from "js-cookie";

export class AuthHelper {
  static clearCookiesStorage = () => {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  };

  static clearCredentials = () => {
    localStorage.clear();
    sessionStorage.clear();
    // console.log("cleared credentials");
    this.clearCookiesStorage();
    // window.location.replace("/");
  };

  static getCookieStorage = (name: string) => {
    const jsonCookie = Cookies.get(name);

    return jsonCookie == null ? null : JSON.parse(jsonCookie);
  };

  static setCookieStorage = (name: string, value: any) => {
    if (typeof value === "string") {
      Cookies.set(name, value);
      return;
    }
    const jsonValue = JSON.stringify(value);
    Cookies.set(name, value);
  };

 

  static setCredentials = (name: string, value: any, setAsCookie = false) => {
    // localstorage
    const jsonValue = JSON.stringify(value);
    // console.log(name, value, jsonValue);
    if (typeof value === "string") {
      localStorage.setItem(name, value);
      if (setAsCookie) {
        this.setCookieStorage(name, value);
      }
      return;
    }

    localStorage.setItem(name, jsonValue);
    if (setAsCookie) {
      this.setCookieStorage(name, jsonValue);
    }
  };

  static getCredentials = (name: string,) => {
    // localstorage
    const localStore = localStorage.getItem(name);

    let parsedCookie, parsedLocalStore;
    // console.log(cookieStore, localStore);

    parsedLocalStore = StringHelper.isJSON(localStore)
      ? JSON.parse(localStore!)
      : localStore;
   

    return  parsedLocalStore 
  };
}
